import React from 'react';

import SvgIcon from '../SvgIcon/SvgIcon';

function LinkedinIcon(props) {
    return (
        <SvgIcon {...props}>
            <path d="M6.15 4.08333C6.15 5.23417 5.225 6.16667 4.08333 6.16667C2.94167 6.16667 2.01667 5.23417 2.01667 4.08333C2.01667 2.93333 2.94167 2 4.08333 2C5.225 2 6.15 2.93333 6.15 4.08333ZM6.16667 7.83333H2V21.1667H6.16667V7.83333ZM12.8183 7.83333H8.67833V21.1667H12.8192V14.1675C12.8192 10.2758 17.8433 9.9575 17.8433 14.1675V21.1667H22V12.7242C22 6.1575 14.565 6.39667 12.8183 9.62917V7.83333Z" />
        </SvgIcon>
    );
}

export default LinkedinIcon;
